module.exports = __webpack_public_path__ + "static/media/proforma-invoices.a049535b.svg";